import { create } from "zustand";
import type { TChatStore } from "./chat-store.types";

export { chatStoreInitialState } from "./chat-store.initial-state";
export { selectOlderMessages } from "./message";

import { chatStoreInitialState } from "./chat-store.initial-state";
import {
  createConversationActions,
  createConversationListActions,
} from "./conversation";
import {
  createMessageListActions,
  createNewMessageActions,
  createMessageUnreadActions,
  createMessageStatusActions,
} from "./message";
import { createConnectionActions } from "./connection";
import { createTabsActions, createPhoneActions } from "./ui";

export const useChatStore = create<TChatStore>()((set) => ({
  ...chatStoreInitialState,

  ...createConversationActions(set),
  ...createConversationListActions(set),

  ...createMessageListActions(set),
  ...createNewMessageActions(set),
  ...createMessageUnreadActions(set),
  ...createMessageStatusActions(set),

  ...createConnectionActions(set),

  ...createTabsActions(set),
  ...createPhoneActions(set),

  resetStore: () => set(() => ({ ...chatStoreInitialState })),
}));
